import React from "react";
import { Grid, Box,Hidden } from "@mui/material";
import 'react-alice-carousel/lib/alice-carousel.css'; // requires a loader
// import "react-responsive-carousel/lib/styles/ca"
import AliceCarousel from 'react-alice-carousel';
import FlightBooking from "../../assets/images/FlightBooking.jpg";
import { useSelector } from "react-redux";
const CarouselInterHoliday = () => {
  const {hotel}= useSelector((state)=>state.home)
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 4 },
};
const items=hotel&&hotel?.result.map((i,index)=>{
  return  <div className="item" data-value="1" >
      <Box style={{width:'90%'}}>
         <Box>
             <img src={i.image} style={{width:'100%'}} />
         </Box>
         <Box style={{textAlign:'initial',padding:10}}>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold'}}>{i.destination}</span><br></br>
             <Box display='flex' alignItems='center'>
             <Box display='flex' alignItems='center'>
             <i class="far fa-clock"></i>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold',marginLeft:5}}>15 Days</span>
             </Box>
             <Box display='flex' alignItems='center' ml={'10px'}>
             <i class="far fa-moon"></i>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold',marginLeft:5}}>7 Nights</span>
             </Box>
             </Box>
             <Box display='flex' alignItems='center'>
             <i class="fa fa-plane-departure"></i>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold',marginLeft:5}}>Departure,</span>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold',marginLeft:5}}>Srinagar</span>

             </Box>
             <Box display='flex' alignItems='center'>
             <i class="fa fa-plane-arrival"></i>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold',marginLeft:5}}>Departure,</span>
             <span style={{color:'#0c2f54',fontFamily:'"Poppins", sans-serif',fontWeight:'bold',marginLeft:5}}>Delhi</span>

             </Box>
             {/* <span>Incredible Singapore</span>
             <p>Starting From ₹24370</p> */}
         </Box>
         <Box style={{background:'#0c2e53',padding:10}}>
           <span style={{color:'white'}}> Starting From ₹130999 </span>
         </Box>
       </Box></div>
 
}) 
const demo = [
  <div className="item" data-value="1">1</div>,
  <div className="item" data-value="2">2</div>,
  <div className="item" data-value="3">3</div>,
  <div className="item" data-value="4">4</div>,
  <div className="item" data-value="5">5</div>,
];

  return (
    <AliceCarousel
    autoPlay
    infinite
        mouseTracking
        items={hotel?items:demo}
        autoPlayInterval={3000}

        responsive={responsive}
        controlsStrategy="alternate"
    />
  
  );
};

export default CarouselInterHoliday;
